import { SVGProps } from 'react'

export const Unread = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    {...props}
  >
    <path
      d="M17.9165 13.0002L12.3808 8.00016M7.61889 8.00016L2.0832 13.0002M1.6665 3.8335L8.4706 8.59636C9.02158 8.98205 9.29707 9.17489 9.59672 9.24959C9.86142 9.31557 10.1383 9.31557 10.403 9.24959C10.7026 9.17489 10.9781 8.98205 11.5291 8.59637L18.3332 3.8335M5.6665 14.6668H14.3332C15.7333 14.6668 16.4334 14.6668 16.9681 14.3943C17.4386 14.1547 17.821 13.7722 18.0607 13.3018C18.3332 12.767 18.3332 12.067 18.3332 10.6668V5.3335C18.3332 3.93336 18.3332 3.2333 18.0607 2.69852C17.821 2.22811 17.4386 1.84566 16.9681 1.60598C16.4334 1.3335 15.7333 1.3335 14.3332 1.3335H5.6665C4.26637 1.3335 3.56631 1.3335 3.03153 1.60598C2.56112 1.84566 2.17867 2.22811 1.93899 2.69852C1.6665 3.2333 1.6665 3.93336 1.6665 5.3335V10.6668C1.6665 12.067 1.6665 12.767 1.93899 13.3018C2.17867 13.7722 2.56112 14.1547 3.03153 14.3943C3.56631 14.6668 4.26637 14.6668 5.6665 14.6668Z"
      stroke="#667085"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
